import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button, Container, Row, Col, Form, Dropdown, DropdownButton, Spinner } from 'react-bootstrap'
import { BsPerson } from 'react-icons/bs';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import { useSelector, useDispatch } from 'react-redux';
import { updateContactsAction } from '../../../Redux/Contacts/action';
import { toast } from "react-toastify";


export default function EditContact({ show, handleClose, data }) {
  const dispatch = useDispatch();
  const [showSpinner, setSpinner] = useState(false);

  const [formData, setFormData] = useState({
    name: data?.name,
    phone: data?.phone,
    email: data?.email,
    companyName: data?.companyName,
    country: data?.country,
    address: data?.address,
    city: data?.city,
    state: data?.state,
    zipCode: data?.zipCode,
    customFields: data?.customFields?.map(field => ({ ...field })), 
  });

  useEffect(() => {
    setFormData(prevData => ({
      ...data,
      customFields: data?.customFields?.map(field => ({ ...field })),
    }));
  }, [data]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handlePhoneChange = (value, data, event) => {
    setFormData((prevData) => ({ ...prevData, phone: value }));
  };

  const handleFieldTypeSelect = (fieldType) => {
    if (fieldType) {
      setFormData((prevData) => {
        const updatedFields = [
          ...prevData.customFields,
          { [fieldType]: `` },
        ];
        return { ...prevData, customFields: updatedFields };
      });
    }
  };

  const handleChangeCustomField = (e, index) => {
    const { value } = e.target;
    setFormData((prevData) => {
      const updatedFields = [...prevData.customFields];
      const fieldName = Object.keys(updatedFields[index])[0];
      updatedFields[index][fieldName] = value;
      return { ...prevData, customFields: updatedFields };
    });
  };


  const handleSaveChanges = async () => {
    setSpinner(true)
    const res = await updateContactsAction(dispatch, data.id, formData)
    if (res.success) {
      setSpinner(false)
      toast.success("Contact Updated", toastConfig);
      handleClose()
    }
  };

  const toastConfig = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
  };


  return (
    <Modal show={show} onHide={handleClose} size='lg' scrollable>
      <Modal.Header >
        <strong className='contact-p-tag-large'>Edit Contact</strong>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={3} className='border-right d-flex flex-column align-items-center'>
              <div className='custom-border-2 '>
                <BsPerson size={30} color='white' />
              </div>
              <p className='contact-p-tag-large mt-3 '>{data?.name}</p>
              <div className='w-100 d-flex align-items-center p-1 custom-border-radius mt-3'>
                <BsPerson size={16} className='m-1 ' />
                Profile
              </div>
            </Col>
            <Col>
              <Form>
                <p>MAIN DETAILS</p>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='name' value={formData?.name} placeholder="Enter full name" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>

                <PhoneInput country={'us'} value={formData?.phone} onChange={handlePhoneChange} className='mb-3 custom-input-value-color' />

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="email" name='email' value={formData?.email} placeholder="Enter email" onChange={handleChange}  className='custom-input-value-color' />
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='companyName' value={formData?.companyName} placeholder="Enter company name" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>

                <p>ADDRESS</p>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='country' value={formData?.country} placeholder="Enter country" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='address' value={formData?.address} placeholder="Enter address" onChange={handleChange} className='custom-input-value-color' />
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='city' value={formData?.city} placeholder="Enter city" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='state' value={formData?.state} placeholder="Enter state" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" name='zipCode' value={formData?.zipCode} placeholder="Enter zipcode" onChange={handleChange} className='custom-input-value-color'/>
                </Form.Group>
                
                {formData.customFields?.map((field, index) => {
                  const fieldName = Object.keys(field)[0];
                  return(
                  <Form.Group key={index} className="mb-3" controlId={`customField-${index}`}>
                    <Form.Label>{fieldName}</Form.Label>
                    <Form.Control
                      type="text"
                      value={field[Object.keys(field)[0]] || ''}
                      onChange={(e) => handleChangeCustomField(e, index)}
                      placeholder=''
                    />
                  </Form.Group>
                )})}
                
                <DropdownButton
                  title='+ Add'
                  onSelect={handleFieldTypeSelect}
                  id="fieldTypeDropdown"
                  variant='info'
                >
                  <Dropdown.Item eventKey="email">Email</Dropdown.Item>
                  <Dropdown.Item eventKey="phone">Phone</Dropdown.Item>
                  <Dropdown.Item eventKey="website">Website</Dropdown.Item>
                  <Dropdown.Item eventKey="instagram">Instagram</Dropdown.Item>
                  <Dropdown.Item eventKey="facebook">Facebook</Dropdown.Item>
                  <Dropdown.Item eventKey="twitter">Twitter</Dropdown.Item>
                  <Dropdown.Item eventKey="youtube">YouTube</Dropdown.Item>
                  <Dropdown.Item eventKey="linkedin">LinkedIn</Dropdown.Item>
                  <Dropdown.Item eventKey="custom">Custom Field</Dropdown.Item>
                </DropdownButton>


              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className='custom-button'>
          Close
        </Button>
        {/* <Button variant="primary" onClick={handleSaveChanges} className='custom-button'>
          Save Changes
        </Button> */}
        {!showSpinner ? <Button variant="primary" onClick={handleSaveChanges} className='custom-button'>
          Save Changes
        </Button> :
          <Button variant="primary" className='custom-button'>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" variant='light' className='mr-2' />
            Loading...
          </Button>}
      </Modal.Footer>
    </Modal>
  )
}
